import {
  Button,
  ButtonGroup,
  Modal,
  ModalIcon,
  Stack,
  TextBody,
  TextTitle,
} from '@pypestream/design-system';

export const CommonConfirmationModal = ({
  headerText,
  headerTextAlign = 'start',
  bodyText,
  bodyTextAlign = 'start',
  cancelText = 'Cancel',
  confirmText = 'Confirm',
  isModalOpened,
  onClose,
  onConfirm,
}: {
  headerText: string;
  headerTextAlign?: 'start' | 'center' | 'end' | 'justify';
  bodyText: string;
  bodyTextAlign?: 'start' | 'center' | 'end' | 'justify';
  cancelText?: string;
  confirmText?: string;
  isModalOpened?: boolean;
  onClose?: () => void;
  onConfirm?: () => void;
}) => {
  return (
    <Modal
      open={isModalOpened}
      size="medium"
      stayOnClickOutside
      stayOnEsc
      onClose={onClose}
    >
      <ModalIcon
        name="error"
        slot="header"
        style={{ display: 'flex', justifyContent: 'center' }}
      />
      <Stack slot="header" alignItems="center" direction="column">
        <TextTitle size="small" textAlign={headerTextAlign}>
          {headerText}
        </TextTitle>
        <TextBody variant="secondary" textAlign={bodyTextAlign}>
          {bodyText}
        </TextBody>
      </Stack>
      <ButtonGroup align="center" slot="footer">
        <Button variant="secondary" size="large" width="full" onClick={onClose}>
          {cancelText}
        </Button>
        <Button
          variant="danger"
          size="large"
          width="full"
          onClick={() => {
            onClose?.();
            onConfirm?.();
          }}
        >
          {confirmText}
        </Button>
      </ButtonGroup>
    </Modal>
  );
};
